import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopEmployersByISCED4 = async (urlDataAPI: any) => {
    const { exportType, hubIds, isceD4Codes, locations, fromTimeline, toTimeline, isEntryLevel } = urlDataAPI;
    const { path, method } = endpoints.educationCareerPath.exportTopEmployersByISCED4;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds, isceD4Codes, locations, fromQuarter: fromTimeline, toQuarter: toTimeline, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};